import { ORDER_ADV_STATUSES, OrderAdvStatus } from '../types/order-adv-status.type';

export const formatAdvStatus = (advStatus: OrderAdvStatus) => {
  switch (advStatus) {
    case ORDER_ADV_STATUSES.INPUT:
      return 'En cours';
    case ORDER_ADV_STATUSES.VALIDATE:
      return 'Validé';
    case ORDER_ADV_STATUSES.PROCESSED:
      return 'Traité';
    case ORDER_ADV_STATUSES.ARCHIVED:
      return 'Archivé';
    case ORDER_ADV_STATUSES.CANCELED:
      return 'Annulé';
  }
};
